<template>
<v-container fluid class="container-whitelist">
    <!-- <v-layout md1 pd1 mb-4>
      <v-card dark width="100%" class="card">
        <v-card-title>
          <v-flex lg3 md1 style="font-size:26px;" class="text-xs-left">
            <span>Settings</span>
          </v-flex>
        </v-card-title>
      </v-card>
    </v-layout> -->
    <v-layout justify-start column fill-height id="whitelistpage">
        <v-tabs slot="extension" v-model="tabIndex" color="dark" dark>
        <v-tabs-slider color="yellow" />
        <v-tab
            v-for="item in tabMenu"
            :key="item"
            style="text-transform: capitalize;"
        >{{ item }}</v-tab>
        </v-tabs>
    </v-layout>

    <v-flex v-if="tabIndex == 0">
        <v-layout lg md12 mt-3 style="padding: 20px 0;">
            <v-flex text-lg-right>
                <v-btn @click="createUploadFile()" id="btn-upload-csv" style="outline: none;">
                    <v-icon dark class="mr-2">
                        cloud_upload
                    </v-icon>
                    <span id='btn-box-inside'>Upload CSV</span>
                </v-btn>
                <v-btn @click="addUser()" id="btn-adduser" style="outline: none;">
                    <v-icon dark class="mr-2">
                        person_add_alt
                    </v-icon>
                    <span id='btn-box-inside'>Add User</span>
                </v-btn>
            </v-flex>
        </v-layout>

        <!-- Dialog Add User -->
        <v-layout>
            <v-dialog v-model="isDialogAddUserShown"
                        persistent
                        max-width="550px"
                        min-height="1050px">
                <v-card dark>
                    <v-toolbar flat>
                        <v-toolbar-title style="color: #cccccc;">Add User</v-toolbar-title>
                        <v-spacer />
                        <v-btn
                            icon
                            dark
                            style="outline: none;"
                            @click="username || hostname || database_type ? isDialogConfirmCancleAddUserShown = true: isDialogAddUserShown = false"
                        >
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-text-field v-model="username"
                                :rules="[rules.required]"
                                label="Username"
                                id="text-username"
                        />
                        <v-select v-model="hostname"
                            :items="hostname_item"
                            :rules="[rules.required]"
                            label="Hostname"
                            id="text-hostname"
                        />
                        <v-select v-model="database_type"
                            :items="database_type_item"
                            :rules="[rules.required]"
                            label="Database Type"
                            id="text-datatype"
                        />
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            slot="activator"
                            class="white--text"
                            color="green darken-1"
                            depressed
                            style="outline: none;"
                            @click.native="isDialogConfirmAddUserShown = true"
                            id="btn-save-adduser"
                        >
                            Save
                            <v-icon size="30" right>save</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

        <!-- Dialog Edit User -->
        <v-layout>
            <v-dialog v-model="isDialogEditUserShown"
                        persistent
                        max-width="550px"
                        min-height="1050px">
                <v-card dark>
                    <v-toolbar flat>
                        <v-toolbar-title>Edit User</v-toolbar-title>
                        <v-spacer />
                        <v-btn
                            icon
                            dark
                            style="outline: none;"
                            @click="isDialogEditUserShown = false"
                        >
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-text-field v-model="username"
                                :rules="[rules.required]"
                                label="Username"/>
                        <v-select v-model="hostname"
                            :items="hostname_item"
                            :rules="[rules.required]"
                            label="Hostname" />
                        <v-select v-model="database_type"
                            :items="database_type_item"
                            :rules="[rules.required]"
                            label="Database Type" />
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            slot="activator"
                            class="white--text"
                            color="green darken-1"
                            depressed
                            style="outline: none;"
                            @click.native="isDialogConfirmEditUserShown = true">
                            Save
                            <v-icon size="30" right>save</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

        <!-- Dialog Confirm Add User -->
        <div class="text-xs-center">
            <v-dialog
            v-model="isDialogConfirmAddUserShown"
            width="500"
            >
            <v-card>
                <v-card-title
                    class="headline grey darken-4"
                    style="color: #cccccc;"
                    primary-title
                >
                    Confirm Add User
                </v-card-title>

                <v-card-text class="text-md-left">
                    Are you sure add user <span style="color: green;">Yes</span> or <span style="color: red;">No</span> ?
                </v-card-text>

                <v-card-actions>
                <v-spacer />
                <v-btn
                    color="text-light red darken-1"
                    style="outline: none;"
                    @click="isDialogConfirmAddUserShown = false, isDialogAddUserShown = false"
                >
                    No
                </v-btn>
                <v-btn
                    class="text-light green darken-1"
                    style="outline: none;"
                    @click="conAddUser()"
                >
                    Yes
                </v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
        </div>

        <!-- Dialog Confirm cancel Add User -->
        <div class="text-xs-center">
            <v-dialog
            v-model="isDialogConfirmCancleAddUserShown"
            width="500"
            >
            <v-card>
                <v-card-title
                    class="headline grey darken-4"
                    style="color: #cccccc;"
                    primary-title
                >
                    Confirm Cancel Add User
                </v-card-title>

                <v-card-text class="text-md-left">
                    <p>Are you sure cancel add user <span style="color: #0288D1;">Yes</span> or <span style="color: red;">No</span> ?</p>
                    <p class="red--text">The entered information will not be recorded.</p>
                </v-card-text>

                <v-card-actions>
                <v-spacer />
                <v-btn
                    color="text-light red darken-1"
                    style="outline: none;"
                    @click="isDialogConfirmCancleAddUserShown = false"
                >
                    No
                </v-btn>
                <v-btn
                    style="outline: none;"
                    class="text-light light-blue darken-2"
                    @click="conCancleAddUser()"
                >
                    Yes
                </v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
        </div>

        <!-- Dialog Confirm Edit User -->
        <div class="text-xs-center">
            <v-dialog
            v-model="isDialogConfirmEditUserShown"
            width="500"
            >
            <v-card>
                <v-card-title
                    class="headline grey darken-4"
                    style="color: #cccccc;"
                    primary-title
                >
                    Confirm Edit User
                </v-card-title>

                <v-card-text class="text-md-left">
                    <p>Are you sure edit  user <span style="color: green;">Yes</span> or <span style="color: red;">No</span> ? </p>
                    <p class="red--text">The entered information will be saved instead of the original information.</p>
                </v-card-text>

                <v-card-actions>
                <v-spacer />
                <v-btn
                    color="text-light red darken-1"
                    style="outline: none;"
                    @click="isDialogConfirmEditUserShown = false"
                >
                    No
                </v-btn>
                <v-btn
                    class="text-light green darken-1"
                    style="outline: none;"
                    @click="conEditUser()"
                >
                    Yes
                </v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
        </div>

        <!-- Dialog Confirm Delete User -->
        <div class="text-xs-center">
            <v-dialog
            v-model="isDialogConfirmDeleteUserShown"
            persistent
            width="500"
            >
            <v-card>
                <v-card-title
                    class="headline grey darken-4"
                    style="color: #cccccc;"
                    primary-title
                >
                    Confirm Delete User
                </v-card-title>

                <v-card-text class="text-md-left">
                    <p>Are you sure delete user <span style="color: green;">Yes</span> or <span style="color: red;">No</span> ?</p>
                </v-card-text>

                <v-card-actions>
                <v-spacer />
                <v-btn
                    color="text-light red darken-1"
                    style="outline: none;"
                    @click="isDialogConfirmDeleteUserShown = false"
                >
                    No
                </v-btn>
                <v-btn
                    class="text-light green darken-2"
                    style="outline: none;"
                    @click="conDeleteUser()"
                >
                    Yes
                </v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
        </div>

        <!-- Dialog Upload File -->
        <v-layout>
            <v-dialog v-model="isDialogUploadFileShown"
                        persistent
                        max-width="550px"
                        min-height="1050px">
                <v-card dark>
                    <v-toolbar flat id="title-dialog-upload">
                        <v-toolbar-title style="color: #cccccc;">Upload File .CSV</v-toolbar-title>
                        <v-spacer />
                        <v-btn
                            icon
                            dark
                            style="outline: none;"
                            @click="isDialogUploadFileShown = false"
                        >
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-select v-model="hostname"
                            :items="mapHostAndType"
                            :rules="[rules.required]"
                            label="Hostname"
                            id="select-host"
                        />
                        <v-flex
                            xs12
                            class="
                            text-xs-left
                            text-sm-left
                            text-md-left
                            text-lg-left
                            "
                        >
                            <div id="btn-box">
                                <v-btn
                                    slot="activator"
                                    color='#FFFFFF'
                                    dark
                                    style="outline: none;"
                                    @click="pickFile"
                                    id="select-file"
                                >
                                    <span id='btn-box-inside'>Choose CSV File</span>
                                </v-btn>
                                <span v-if="fileName" >{{ fileName }}</span>
                            </div>
                                <input
                                    ref="csv"
                                    type="file"
                                    style="display: none"
                                    name="csv"
                                    accept=".csv, .xls, .xlsx, .xlsm"
                                    @change="onFilePicked" >
                        </v-flex>
                        <v-spacer />
                        <div id="text-csv">
                            <span style="color: #FF5252;">*</span>
                            <span>ตัวอย่างรูปแบบเอกสาร รับเฉพาะรูปแบบ</span>
                            <span style="color: #FF5252;">CSV File</span>
                        </div>
                        <v-img :src="example_csv"  max-width="360" />
                        <v-spacer />
                        <v-flex text-lg-left mt-3>
                            <v-alert
                                :value="true"
                                color="error"
                                class="grey darken-4"
                                outline
                            >
                                <v-icon size="18">info</v-icon>
                                <span class="text-light">Username เฉพาะผู้มีสิทธิ์ในการเข้าถึง Hostname เท่านั้น</span>
                            </v-alert>
                        </v-flex>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            slot="activator"
                            class="white--text"
                            color="green darken-1"
                            depressed
                            style="outline: none;"
                            @click="uploadFile"
                            id="btn-save"
                        >
                            Save
                            <v-icon size="30" right>save</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

        <!-- Dialog Notification Upload File -->
        <div class="text-xs-center">
            <v-dialog
            v-model="isDialogConNoticUploadShown"
            width="500"
                >
                <v-card dark>
                    <v-card-title
                        class="headline grey darken-4"
                        style="color: #cccccc;"
                        primary-title
                    >
                        Warning
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        dark
                        style="outline: none;"
                        @click="isDialogConNoticUploadShown = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    </v-card-title>
                    <v-icon size='100px'>info</v-icon>
                    <v-card-text class="text-md-center">
                        <p>Please check hostname on you csv file.</p>
                        <p>Make sure you match all user ?</p>
                    </v-card-text>

                    <div>
                        <v-btn
                            slot="activator"
                            color='#FFFFFF'
                            dark
                            style="outline: none;"
                            @click="pickFile"
                        >
                            <span id='btn-box-inside'>Choose CSV File</span>
                        </v-btn>
                        <!-- <span v-if="fileName">{{ fileName }}</span> -->
                        <!-- <v-card v-if="fileName" >
                        <v-card-title  primary-title>
                            <h3>{{ fileName }}</h3>
                        </v-card-title>
                        </v-card> -->
                    </div>
                </v-card>
            </v-dialog>
        </div>

        <!-- Data Table -->
        <v-layout>
            <v-flex lg12 md12>
                <v-card dark>
                    <v-card-title>
                        <span>User relate personal data in organization</span>
                        <v-spacer />
                        <v-spacer />
                        <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details
                        />
                    </v-card-title>
                    <v-data-table
                        v-model="selected"
                        :headers="headers_wl"
                        :items="datatables"
                        :search="search"
                        :loading="loadTableUser"
                        :pagination.sync="pagination"
                        item-key="_id"
                        >
                    <v-progress-linear slot:progress color="blue" indeterminate></v-progress-linear>
                    <template slot="items" slot-scope="props">
                        <tr>
                            <td>
                                <v-checkbox
                                v-model="props.selected"
                                primary
                                hide-details
                                disabled
                                />
                            </td>
                            <td class="text-xs-left">{{ props.item.username }}</td>
                            <td class="text-xs-left">{{ props.item.hostname }}</td>
                            <td class="text-xs-left">{{ props.item.database_type }}</td>
                            <td class="text-xs-left">{{ props.item.create_date }}</td>
                            <td class="text-xs-center">
                                <v-tooltip bottom>
                                    <v-btn
                                        slot="activator"
                                        flat
                                        icon
                                        style="outline: none;"
                                        @click="editUser(props.item)" >
                                        <v-icon size="24">edit</v-icon>
                                    </v-btn>
                                    <span>Edit</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <v-btn
                                        slot="activator"
                                        flat
                                        icon
                                        style="outline: none;"
                                        @click="deleteUser(props.item)"  >
                                        <v-icon size="22">delete_outline</v-icon>
                                    </v-btn>
                                    <span>Delete</span>
                                </v-tooltip>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:no-results>
                        <v-alert :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                        </v-alert>
                    </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-flex>

    <v-flex v-if="tabIndex == 1">
        <v-layout lg md12 mt-3 style="padding: 20px 0;">
            <!-- <v-flex mg0 lg3 ml-2 style="flex-basis: auto;" >
                <span style="color: #fff; font-size: 22px;"> User ที่มีสิทธิ์ในการรับการแจ้งเตือน</span>
            </v-flex> -->
            <v-flex text-lg-right>
            <v-btn @click="addAlert" id="btn-add-setting-pdpa" style="outline: none;">
                <v-icon dark class="mr-2">
                    mail_outline
                </v-icon>
                <span id='btn-box-inside'>Add Email</span>
            </v-btn>
            </v-flex>
        </v-layout>

        <!-- Dialog Add Alert -->
        <div class="text-xs-center">
            <v-dialog
            v-model="isDialogSettingAlertShown"
            persistent
            width="500"
                >
                <v-card dark>
                    <v-card-title
                        class="headline grey darken-4"
                        style="color: #cccccc;"
                        primary-title
                    >
                    <v-icon size='30px' color="#cccccc">settings</v-icon>
                        Add Email Responsible person
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="isDialogSettingAlertShown = false" style="outline: none;">
                        <v-icon>close</v-icon>
                    </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-text-field v-model="email"
                                :rules="[rules.required]"
                                label="E-mail"
                                id="text-add-email"
                        />
                        <v-select v-model="settimealert"
                            :items="settimealert_item"
                            :rules="[rules.required]"
                            label="Time"
                            id="text-add-time"
                        />
                        <v-select v-model="setOnOffAlert"
                            :items="setOnOffAlert_item"
                            label="Alert"
                            id="text-add-onoff"
                        />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            slot="activator"
                            class="white--text"
                            color="green darken-1"
                            depressed
                            style="outline: none;"
                            @click="saveSetAlert"
                            id="btn-add-setting-save"
                        >
                            Save
                            <v-icon size="30" right>save</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!-- Dialog edit Alert -->
        <div class="text-xs-center">
            <v-dialog
                v-model="isDialogEditAlertShown"
                persistent
                width="500"
            >
                <v-card dark>
                    <v-card-title
                        class="headline grey darken-4"
                        style="color: #cccccc;"
                        primary-title
                    >
                    <v-icon size='30px' color="#cccccc">settings</v-icon>
                        Edit Setting Alert
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="isDialogEditAlertShown = false" style="outline: none;">
                        <v-icon>close</v-icon>
                    </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-text-field v-model="email"
                                :rules="[rules.required]"
                                label="E-mail"/>
                        <v-select v-model="settimealert"
                            :items="settimealert_item"
                            :rules="[rules.required]"
                            label="Time" />
                        <v-select v-model="setOnOffAlert"
                            :items="setOnOffAlert_item"
                            label="Alert" />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            slot="activator"
                            class="white--text"
                            color="green darken-1"
                            depressed
                            style="outline: none;"
                            @click="saveActivity">
                            Save
                            <v-icon size="30" right>save</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!-- Dialog Confirm Delete Activity -->
        <div class="text-xs-center">
            <v-dialog
                v-model="isDialogConfirmDeleteActivityShown"
                persistent
                width="500"
            >
            <v-card>
                <v-card-title
                    class="headline grey darken-4"
                    style="color: #cccccc;"
                    primary-title
                >
                    Confirm Delete Activity Tracking
                </v-card-title>

                <v-card-text class="text-md-left">
                    <p>Are you sure delete activity tracking alert <span style="color: green;">Yes</span> or <span style="color: red;">No</span> ? </p>
                </v-card-text>

                <v-card-actions>
                <v-spacer />
                <v-btn
                    color="text-light red darken-1"
                    style="outline: none;"
                    @click="isDialogConfirmDeleteActivityShown = false"
                >
                    No
                </v-btn>
                <v-btn
                    class="text-light green darken-2"
                    style="outline: none;"
                    @click="conDelActivity()"
                >
                    Yes
                </v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
        </div>

        <!-- Data Table -->
        <v-layout>
            <v-flex lg12 md12>
                <v-card dark>
                    <v-card-title id="table-at">
                        <span>Setting receive alert e-mail</span>
                        <v-spacer />
                        <v-spacer />
                        <v-spacer />
                        <v-spacer />
                        <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details
                        />
                    </v-card-title>
                    <v-data-table
                        v-model="selected"
                        :headers="header_at"
                        :items="datatables_alert"
                        :search="search"
                        :loading="loadTable"
                        :pagination.sync="pagination_at"
                        item-key="_id"
                        >
                    <v-progress-linear slot:progress color="blue" indeterminate></v-progress-linear>
                    <template slot="items" slot-scope="props">
                        <tr>
                            <td>
                                <v-checkbox
                                v-model="props.selected"
                                primary
                                hide-details
                                disabled
                                />
                            </td>
                            <td class="text-xs-left">{{ props.item.email }}</td>
                            <td class="text-xs-center">{{ props.item.time }}</td>
                            <td class="text-xs-center">
                                <div id="btn-switch">
                                    <v-switch
                                        v-model="props.item.sendemail"
                                        color="success"
                                        @change="editSetAlert(props.item)"
                                        hide-details
                                        >
                                    </v-switch>
                                </div>
                            </td>
                            <td class="text-xs-center">
                                <v-tooltip bottom>
                                    <v-btn
                                        slot="activator"
                                        flat
                                        icon
                                        style="outline: none;"
                                        @click="editActivity(props.item)">
                                        <v-icon size="24">edit</v-icon>
                                    </v-btn>
                                    <span>Edit</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <v-btn
                                        slot="activator"
                                        flat
                                        icon
                                        style="outline: none;"
                                        @click="delActivity(props.item)">
                                        <v-icon size="22">delete_outline</v-icon>
                                    </v-btn>
                                    <span>Delete</span>
                                </v-tooltip>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:no-results>
                        <v-alert :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                        </v-alert>
                    </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-flex>

    <v-snackbar
        v-model="snackbar"
        :bottom="false"
        :left="false"
        :multi-line="true"
        :right="false"
        :timeout="5000"
        :top="true"
        :vertical="false">
    {{ snackbartext }}
        <v-btn
            color="pink"
            flat
            style="outline: none;"
            @click="snackbar = false">
        Close
        </v-btn>
    </v-snackbar>
    <v-tour name="recommand-tour-setting-pdpa" :steps="steps" :options="stepOptions" :callbacks="stepCallbacks">
        <template slot-scope="tour">
        <transition name="fade"></transition>
          <v-step
            v-if="tour.steps[tour.currentStep]"
            :key="tour.currentStep"
            :step="tour.steps[tour.currentStep]"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
            :highlight="tour.highlight"
            class="tour-body"
          >
            <template>
              <v-layout slot="header" class="tour-header">
                <img v-if="tour.currentStep == 0" src="../assets/img/login/logo-ilog-256.png" alt="ilog_logo" style="width: 21px; height: 21px; position: relative; top: 5px; left: 50px;">
                <v-icon v-if="tour.currentStep == 1" style="position: relative; left: 70px; color: #fff;">cloud_upload</v-icon>
                <v-icon v-if="tour.currentStep == 2" style="position: relative; left: 130px; color: #fff;">settings</v-icon>
                <v-icon v-if="tour.currentStep == 3" style="position: relative; left: 75px; color: #fff;">cloud</v-icon>
                <v-icon v-if="tour.currentStep == 4" style="position: relative; left: 80px; color: #fff;">folder</v-icon>
                <v-icon v-if="tour.currentStep == 5" style="position: relative; left: 130px; color: #fff;">save</v-icon>
                <v-icon v-if="tour.currentStep == 6" style="position: relative; left: 110px; color: #fff;">person_add_alt</v-icon>
                <v-icon v-if="tour.currentStep == 7" style="position: relative; left: 130px; color: #fff;">settings</v-icon>
                <v-icon v-if="tour.currentStep == 8" style="position: relative; left: 130px; color: #fff;">save</v-icon>
                <v-icon v-if="tour.currentStep == 9" style="position: relative; left: 85px; color: #fff;">notifications</v-icon>
                <v-icon v-if="tour.currentStep == 10" style="position: relative; left: 105px; color: #fff;">mail</v-icon>
                <v-icon v-if="tour.currentStep == 11" style="position: relative; left: 130px; color: #fff;">settings</v-icon>
                <v-icon v-if="tour.currentStep == 12" style="position: relative; left: 130px; color: #fff;">save</v-icon>
                <v-icon v-if="tour.currentStep == 13" style="position: relative; left: 110px; color: #fff;">chat</v-icon>
                <v-flex class="headline font-weight-light" v-html="tour.steps[tour.currentStep].header.title"></v-flex>
              </v-layout>
              <v-layout slot="content" class="tour-content" column>
                <v-flex class="body-2 font-weight-light" my-2>( {{tour.currentStep + 1}} / {{tour.steps.length}} )</v-flex>
                <v-flex class=" body-2 font-weight-light" v-html="tour.steps[tour.currentStep].content" ></v-flex>
              </v-layout>
              <v-layout slot="actions" fill-height align-center justify-center row>
                <v-flex v-if="tour.currentStep == 0" mt-2>
                  <v-btn @click="tour.nextStep" class="tour-btn-start font-weight-regular" block>Start</v-btn>
                  <button @click="tour.skip" class="tour-btn-skip">Skip</button>
                </v-flex>
                <v-flex v-else-if="!tour.isLast" column mt-3>
                  <v-btn @click="tour.previousStep" class="tour-btn-back font-weight-regular" round>Back</v-btn>
                  <v-btn @click="tour.nextStep" class="tour-btn-next font-weight-regular" round>Next</v-btn><br>
                  <button @click="tour.skip" class="tour-btn-skip">Skip</button>
                </v-flex>
                <v-flex v-else>
                  <v-btn @click="tour.finish" class="tour-btn-finish" block>Finish</v-btn>
                </v-flex>
              </v-layout>
            </template>
          </v-step>
      </template>
    </v-tour>
  </v-container>
</template>

<script>
import axios from 'axios'
import jwtDecode from 'jwt-decode'
export default {
  name: 'whiteListPage',
  data () {
      return {
        tabMenu: ['Whitelist', 'Manage Recipient'],
        tabIndex: 0,
        snackbar: false,
        snackbartext: '',
        selected: [],
        example_csv: require('../assets/img/example_csv.png'),
        search: '',
        headers_wl: [
          {
            text: '',
            value: '',
            align: 'left',
            sortable: false
          },
          {
            text: 'Username',
            value: 'username',
            align: 'left',
            sortable: true
          },
          {
            text: 'Hostname',
            value: 'hostname',
            align: 'left',
            sortable: true
          },
          {
            text: 'Database Type',
            value: 'database_type',
            align: 'left',
            sortable: true
          },
          {
            text: 'Create Date',
            value: 'create_date',
            align: 'left',
            sortable: true
          },
          {
            text: 'Action',
            value: 'action',
            align: 'center',
            sortable: false
          }
        ],
        header_at: [
             {
                text: '',
                value: '',
                align: 'left',
                sortable: false
            },
            {
                text: 'E-mail',
                value: 'email',
                align: 'left',
                sortable: true
            },
            {
                text: 'Alert Time',
                value: 'time',
                align: 'center',
                sortable: true
            },
            {
                text: 'Alert',
                value: 'control',
                align: 'center',
                sortable: false
            },
            {
                text: 'Action',
                value: 'action',
                align: 'center',
                sortable: false
            }
        ],
        pagination: {
            descending: false,
            rowsPerPage: 5,
            sortBy: 'username'
        },
        pagination_at: {
            descending: false,
            rowsPerPage: 5,
            sortBy: 'email'
        },
        loadTable: false,
        loadTableUser: false,
        datatables: [],
        datatables_alert: [],
        pdpaControl: true,
        isDialogUploadFileShown: false,
        isDialogConNoticUploadShown: false,
        isDialogAddUserShown: false,
        isDialogEditUserShown: false,
        isDialogSettingAlertShown: false,
        isDialogConfirmAddUserShown: false,
        isDialogConfirmCancleAddUserShown: false,
        isDialogConfirmEditUserShown: false,
        isDialogConfirmDeleteUserShown: false,
        isDialogEditAlertShown: false,
        isDialogConfirmDeleteActivityShown: false,
        id: '',
        username: '',
        hostname: '',
        database_type: '',
        create_date: '',
        hostname_item: [],
        mapHostAndType: [],
        database_type_item: [],
        fileName: '',
        // fileUrl: '',
        csvFile: '',
        data_result: '',
        fileinput: '',
        email: '',
        setOnOffAlert: false,
        setOnOffAlert_item: [
            {
                text: 'On',
                value: true
            },
            {
                text: 'Off',
                value: false
            }
        ],
        settimealert: '15m',
        settimealert_item: [
            {
                text: '1 นาที',
                value: '1m'
            },
            {
                text: '5 นาที',
                value: '5m'
            },
            {
                text: '10 นาที',
                value: '10m'
            },
            {
                text: '15 นาที',
                value: '15m'

            },
            {
                text: '30 นาที',
                value: '30m'
            },
            {
                text: '1 ชั่วโมง',
                value: '1h'
            },
            {
                text: '12 ชั่วโมง',
                value: '12h'
            },
            {
                text: '1 วัน',
                value: '1d'
            }
        ],
        enableSendEmail: false,
        rules: {
            required: v => !!v || 'This field is required.',
            min: v => v.length >= 6 || 'Min 6 characters'
        },
        role: '',
        user: '',
        ampid: '',
        recommend: false,
        stepOptions: {
          useKeyboardNavigation: true,
          highlight: true,
          labels: {
            buttonSkip: 'ข้าม',
            buttonPrevious: 'ย้อนกลับ',
            buttonNext: 'ต่อไป',
            buttonStop: 'สิ้นสุด'
          }
        },
        stepCallbacks: {
            onSkip: this.finishStepTour,
            onFinish: this.finishStepTour
        },
        steps: [
            {
                target: '#whitelistpage',
                header: {
                    title: 'Get Started with iLog 2.6'
                },
                content: `<h5>พบกับฟีเจอร์ใหม่ Activity Tracking</h5><span>ที่จะช่วยให้คุณตั้งค่าผู้ใช้ที่คุณอนุญาติให้เข้าใช้งานอุปกรณ์ PDPA <br>และแจ้งเตือนคุณเมื่อมีผู้ใช้คนอื่นเข้ามาใช้งาน</span>`,
                params: {
                    highlight: false,
                    enableScrolling: false
                },
                before: () => {
                    setTimeout(() => {
                        this.datatables = [
                            {
                                _id: '6098af5450cec034d4f41ac5',
                                username: 'Username One',
                                hostname: 'example.co.th',
                                database_type: 'fileshare',
                                create_date: '20/4/2021  10:41:33',
                                edit_date: '10/5/2021  10:58:11',
                                action: ''
                            }
                        ]
                    }, 500)
                }
            },
            {
                target: '#btn-upload-csv',
                header: {
                    title: 'ปุ่มอัพโหลดไฟล์ CSV'
                },
                content: `<span>คุณสามารถอัพโหลดรายชื่อที่คุณอนุญาติได้ด้วยไฟล์ CSV</span>`,
                params: {
                    highlight: true,
                    enableScrolling: false
                },
                before: () => {
                    this.isDialogUploadFileShown = false
                }
            },
            {
                target: '#title-dialog-upload',
                header: {
                    title: 'หน้าตั้งค่า'
                },
                content: `<span>เพียงคุณเตรียมไฟล์ CSV ที่มีรายชื่อที่คุณต้องการอนุญาติในการเข้าถึง<br>และเลือกโฮสที่คุณต้องการ</span>`,
                params: {
                    placement: 'right',
                    highlight: true,
                    enableScrolling: false
                },
                before: () => {
                    this.mapHostAndType = ['example.co.th', 'ilog.ai']
                    this.hostname = 'example.co.th'
                    this.isDialogUploadFileShown = true
                }

            },
            {
                target: '#select-host',
                header: {
                    title: 'เลือกโฮสต์ที่ต้องการ'
                },
                content: `<span>โฮสต์ที่คุณสามารถเลือกได้<br>จะมาจากอุปกรณ์ทั้งหมดที่อยู่ในหมวด PDPA</span>`,
                params: {
                    highlight: false,
                    enableScrolling: false
                }
            },
            {
                target: '#select-file',
                header: {
                    title: 'เลือกไฟล์ที่ต้องการ'
                },
                content: `<span>หลังจากนั้นคุณก็กดเลือกไฟล์ CSV จากเครื่องของคุณ</span>`,
                params: {
                    highlight: true,
                    enableScrolling: false
                }
            },
            {
                target: '#btn-save',
                header: {
                    title: 'ปุ่มบันทึก'
                },
                content: `<span>ตรวจเช็คโฮสต์และไฟล์ CSV ของคุณว่าถูกต้องหรือไม่<br>จากนั้นก็กด SAVE ก็เสร็จเรียบร้อย</span>`,
                params: {
                    placement: 'left',
                    highlight: true,
                    enableScrolling: false
                },
                before: () => {
                    this.isDialogUploadFileShown = true
                }
            },
            {
                target: '#btn-adduser',
                header: {
                    title: 'ปุ่มเพิ่มรายชื่อ'
                },
                content: `<span>คุณสามารถเพิ่มรายชื่อผู้ที่ได้รับอนุญาติเป็นรายบุคคลได้</span>`,
                params: {
                    highlight: true,
                    enableScrolling: false
                },
                before: () => {
                    this.isDialogUploadFileShown = false
                    this.isDialogAddUserShown = false
                }
            },
            {
                target: '#text-username',
                header: {
                    title: 'หน้าตั้งค่า'
                },
                content: `<span>พิมพ์รายชื่อที่คุณต้องการ<br>เลือกโฮสต์และชนิดฐานข้อมูล</span>`,
                params: {
                    placement: 'right',
                    highlight: false,
                    enableScrolling: false
                },
                before: () => {
                    this.username = 'UsernameA'
                    this.hostname = 'example.co.th'
                    this.hostname_item = ['example.co.th', 'ilog.ai']
                    this.database_type = 'fileshare'
                    this.isDialogAddUserShown = true
                }
            },
            {
                target: '#btn-save-adduser',
                header: {
                    title: 'ปุ่มบันทึก'
                },
                content: `<span>ตรวจสอบข้อมูลของคุณว่าถูกต้องเรียบร้อยหรือไม่ <br>แล้วกด SAVE เพื่อบันทึกข้อมูล</span>`,
                params: {
                    highlight: true,
                    enableScrolling: false
                },
                before: () => {
                    this.isDialogAddUserShown = true
                    this.tabIndex = 0
                }
            },
            {
                target: '#table-at',
                header: {
                    title: 'Manage Recipient'
                },
                content: `<span>เมนู Manage Recipient จะเป็นการตั้งค่าการแจ้งเตือน<br>ไปยังอีเมล์เมื่อมีผู้ใช้งานที่คุณไม่ได้เพิ่มรายชื่อไว้เข้ามาใช้งาน<br>อุปกรณ์ของคุณตามที่คุณได้ตั้งค่าไว้</span>`,
                params: {
                    highlight: false,
                    enableScrolling: false
                },
                before: () => {
                    this.isDialogAddUserShown = false
                    this.tabIndex = 1
                    setTimeout(() => {
                        this.datatables_alert = [
                            {
                                _id: '6062cd21ec4fa95670f8e604',
                                email: 'example@email.com',
                                time: '1h',
                                sendemail: false
                            }
                        ]
                    }, 500)
                }
            },
            {
                target: '#btn-add-setting-pdpa',
                header: {
                    title: 'ตั้งค่าแจ้งเตือน'
                },
                content: `<span>คุณสารมารถคลิกเพื่อเพิ่มอีเมล์ในการแจ้งเตือน</span>`,
                params: {
                    highlight: true,
                    enableScrolling: false
                },
                 before: () => {
                     this.isDialogSettingAlertShown = false
                 }
            },
            {
                target: '#text-add-email',
                header: {
                    title: 'การตั้งค่า'
                },
                content: `<span>กรอกอีเมล์ที่คุณต้องการ <br>เลือกเวลาในการแจ้งเตือน<br>และเปิดหรือปิดการแจ้งเตือน </span>`,
                params: {
                    placement: 'right',
                    highlight: false,
                    enableScrolling: false
                },
                before: () => {
                    this.email = 'example@email.com'
                    this.settimealert = '5m'
                    this.isDialogSettingAlertShown = true
                }
            },
            {
                target: '#btn-add-setting-save',
                header: {
                    title: 'ปุ่มบันทึก'
                },
                content: `<span>ตรวจสอบข้อมูลการแจ้งเตือนของคุณว่าถูกต้องเรียบร้อยหรือไม่<br>แล้วกด SAVE เพื่อบันทึกข้อมูล</span>`,
                params: {
                    placement: 'right',
                    highlight: true,
                    enableScrolling: false
                },
                before: () => {
                    this.isDialogSettingAlertShown = true
                }
            },
            {
                target: '#table-at',
                header: {
                    title: 'Support iLog'
                },
                content: `<span>หากคุณมีข้อสงสัยเพิ่มเติมสามารถคลิกที่ปุ่มเมนู Manual ที่แถบเมนู <br>หรือสามารถติดต่อหา Support iLog ได้ผ่านทุกช่องทาง</span>`,
                params: {
                    highlight: false,
                    enableScrolling: false
                },
                before: () => {
                    this.isDialogSettingAlertShown = false
                }
            }
        ]
      }
    },
    async created () {
        this.token = sessionStorage.getItem('user-token')
        this.decoded = jwtDecode(this.token)
        this.ampid = this.decoded.ampid
        this.role = this.decoded.role
        this.user = this.decoded.username
        this.getDataTable()
        this.getControl()
        this.getHostname()
        if (this.role === 'user') {
            let response = await axios.post(apiUrl + '/api/status/recommend', {
                command: 'get'
            })
            this.recommend = response.data.settingpdpa
        }
    },
    methods: {
        async getControl () {
            this.loadTable = true
            const response = await axios.post(apiUrl + '/api/whitelist/getActivityTracking')
            this.datatables_alert = response.data
            this.loadTable = false
        },
        async getDataTable () {
            this.loadTableUser = true
            let response = await axios.get(apiUrl + '/api/whitelist/datatables')
            this.datatables = response.data
            this.loadTableUser = false
        },
        async getHostname () {
            let response = await axios.get(apiUrl + '/api/whitelist/hostnames')
            for (let element of response.data.hostnames) {
                this.hostname_item.push(element)
            }
            for (let element of response.data.mapHostAndType) {
                // console.log(element)
                this.database_type_item.push({
                    text: element.database_type,
                    value: element.database_type
                })
                this.mapHostAndType.push({
                    text: `${element.hostname} (${element.database_type})`,
                    value: [{hostname: element.hostname, database_type: element.database_type}]
                })
            }
        },
        addUser () {
            this.resetValue()
            this.isDialogAddUserShown = true
            window.analytics.track(`[Setting][Whitelist][AddUser]`, {}, {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
        },
        async conAddUser () {
            window.analytics.track(`[Setting][Whitelist][AddUser][Submit]`, {
                value: {
                    username: this.username,
                    hostname: this.hostname,
                    database_type: this.database_type
                }
            }, {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
            this.isDialogAddUserShown = false
            this.isDialogConfirmAddUserShown = false
            if (this.username && this.hostname) {
                try {
                    await axios.post(apiUrl + '/api/whitelist/adduser', {
                        username: this.username,
                        hostname: this.hostname,
                        database_type: this.database_type
                    })
                    this.getDataTable()
                    this.snackbartext = 'Add whitelist user success'
                    this.snackbar = true
                } catch (e) {
                    console.log(e)
                }
            }
            this.resetValue()
        },
        conCancleAddUser () {
            this.resetValue()
            this.isDialogAddUserShown = false
            this.isDialogConfirmCancleAddUserShown = false
        },
        editUser (items) {
            window.analytics.track(`[Setting][Whitelist][Action][Edit]`, {}, {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
            this.id = items._id
            this.username = items.username
            this.hostname = items.hostname
            this.database_type = items.database_type
            this.create_date = items.create_date
            this.isDialogEditUserShown = true
        },
        async conEditUser () {
            window.analytics.track(`[Setting][Whitelist][Action][Edit][Submit]`, {
                value: {
                    _id: this.id,
                    username: this.username,
                    hostname: this.hostname,
                    database_type: this.database_type,
                    create_date: this.create_date
                }
            }, {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
            this.isDialogEditUserShown = false
            this.isDialogConfirmEditUserShown = false

            try {
                await axios.post(apiUrl + '/api/whitelist/edituser', {
                    _id: this.id,
                    username: this.username,
                    hostname: this.hostname,
                    database_type: this.database_type,
                    create_date: this.create_date
                })
                this.getDataTable()
                this.snackbartext = 'Edit whitelist user complete'
                this.snackbar = true
                this.resetValue()
            } catch (e) {
                console.log(e)
            }
        },
        deleteUser (items) {
            window.analytics.track(`[Setting][Whitelist][Action][Delete]`, {}, {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
            this.id = items._id
            this.username = items.username
            this.hostname = items.hostname
            this.database_type = items.database_type
            this.isDialogConfirmDeleteUserShown = true
        },
        async conDeleteUser () {
            window.analytics.track(`[Setting][Whitelist][Action][Delete][Submit]`, {
                value: {
                    _id: this.id,
                    username: this.username,
                    hostname: this.hostname,
                    database_type: this.database_type
                }
            }, {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
            this.isDialogConfirmDeleteUserShown = false
            try {
                await axios.post(apiUrl + '/api/whitelist/deleteuser', {
                    _id: this.id,
                    username: this.username,
                    hostname: this.hostname,
                    database_type: this.database_type
                })
                this.getDataTable()
                this.snackbartext = 'Delete whitelist user complete'
                this.snackbar = true
                this.resetValue()
            } catch (e) {
                console.log(`Error delete User ${this.username}`)
            }
        },
        createUploadFile () {
            this.resetValue()
            this.isDialogUploadFileShown = true
            window.analytics.track(`[Setting][Whitelist][UploadCsv]`, {}, {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
        },
        pickFile () {
            this.$refs.csv.click()
            this.isDialogConNoticUploadShown = false
        },
        onFilePicked (e) {
            const files = e.target.files || e.dataTransfer.files
            this.fileName = files[0].name
            if (files[0].type !== 'application/vnd.ms-excel') {
                this.isDialogConNoticUploadShown = true
                this.resetValue()
            }
            if (!files.length) return
            this.csvFile = files[0]
        },
        uploadFile () {
             window.analytics.track(`[Setting][Whitelist][UploadCsv][Submit]`, {}, {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
            // console.log(this.database_type)
            if (this.hostname === '' || !this.csvFile) {
                this.isDialogConNoticUploadShown = true
                this.resetValue()
                return
            }
            this.isDialogUploadFileShown = false
            const reader = new FileReader()
            reader.onload = async (e) => {
                // console.log(e.target.result)
                this.fileinput = e.target.result
                let userNameList = this.fileinput.split('\r\n').filter((data) => data !== '')
                let userNameListfillter = []
                userNameList.map(el => {
                    let tmp = el.split(',')
                    tmp.map(item => {
                        if (item !== '') {
                            userNameListfillter.push(item)
                        }
                    })
                })
                try {
                    await axios.post(apiUrl + '/api/whitelist/uploadcsv', {
                        username: userNameListfillter,
                        hostname: this.hostname[0].hostname,
                        database_type: this.hostname[0].database_type
                    })
                    this.getDataTable()
                    this.snackbartext = 'Upload CSV to whitelist success'
                    this.snackbar = true
                    this.resetValue()
                } catch (e) {
                    console.log(e)
                }
            }
            reader.readAsText(this.csvFile)
        },
        addAlert () {
            window.analytics.track(`[Setting][Notification][AddEmail]`, {}, {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
            this.email = ''
            this.settimealert = '15m'
            this.setOnOffAlert = false
            this.isDialogSettingAlertShown = true
        },
        async saveSetAlert () {
            window.analytics.track(`[Setting][Notification][AddEmail][Submit]`, {
                value: {
                    command: 'user',
                    email: this.email,
                    time: this.settimealert,
                    sendemail: this.setOnOffAlert
                }
            }, {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
            this.isDialogSettingAlertShown = false
            // console.log(this.email)
            // console.log(this.settimealert)
            if (this.email && this.settimealert) {
                try {
                    await axios.post(apiUrl + '/api/whitelist/addemailalert', {
                        command: 'user',
                        email: this.email,
                        time: this.settimealert,
                        sendemail: this.setOnOffAlert
                    })
                    this.getControl()
                    // this.snackbartext = 'Update setting alert success'
                    // this.snackbar = true
                    this.resetValue()
                } catch (e) {
                    console.log(e)
                }
            }
            // this.resetValue()
        },
        async editSetAlert (e) {
            window.analytics.track(`[Setting][Notification][Alert]`, {
                value: {
                    id: e._id,
                    email: e.email,
                    time: e.time,
                    sendemail: e.sendemail
                }
            }, {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
            try {
                await axios.post(apiUrl + '/api/whitelist/editSetAlert', {
                    id: e._id,
                    email: e.email,
                    time: e.time,
                    sendemail: e.sendemail
                })
                // this.loadTable = false
                // this.isDialogEditAlertShown = false
            } catch (error) {
                console.log(error)
                // this.isDialogEditAlertShown = false
                // this.loadTable = false
            }
            // this.loadTable = false
        },
        editActivity (e) {
            window.analytics.track(`[Setting][Notification][Action][Edit]`, {}, {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
            this.id = e._id
            this.email = e.email
            this.settimealert = e.time
            this.setOnOffAlert = e.sendemail
            this.isDialogEditAlertShown = true
            // this.saveActivity()
            // this.editSetAlert(e)
        },
        async saveActivity () {
            window.analytics.track(`[Setting][Notification][Action][Edit][Submit]`, {}, {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
            this.loadTable = true
            this.isDialogEditAlertShown = false
            try {
                // this.isDialogEditAlertShown = false
                // console.log('Click++++ 000000')
                await axios.post(apiUrl + '/api/whitelist/editSetAlert', {
                    id: this.id,
                    email: this.email,
                    time: this.settimealert,
                    sendemail: this.setOnOffAlert
                })
                this.loadTable = false
                await this.getControl()
                // this.isDialogEditAlertShown = false
            } catch (error) {
                console.log(error)
                // this.isDialogEditAlertShown = false
                // this.loadTable = false
            }
            // this.loadTable = false
            // this.isDialogEditAlertShown = false
            this.snackbartext = 'Update setting alert success'
            this.snackbar = true
        },
        delActivity (e) {
            window.analytics.track(`[Setting][Notification][Action][Delete]`, {}, {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
            this.email = e.email
            this.id = e._id
            this.isDialogConfirmDeleteActivityShown = true
        },
        async conDelActivity (e) {
            window.analytics.track(`[Setting][Notification][Action][Delete][Submit]`, {}, {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
            try {
                await axios.post(apiUrl + '/api/whitelist/deleteActivityTracking', {
                    command: 'user',
                    id: this.id,
                    email: this.email
                })
                // this.loadTable = false
                this.getControl()
                this.snackbartext = 'Delete setting alert complete'
                this.snackbar = true
            } catch (error) {
                console.log(error)
                // this.loadTable = false
            }
            this.isDialogConfirmDeleteActivityShown = false
        },
        resetValue () {
            this.id = ''
            this.username = ''
            this.hostname = ''
            this.database_type = ''
            this.create_date = ''
            this.csvFile = ''
            this.fileinput = ''
            this.fileName = ''
            this.email = ''
            this.settimealert = ''
            this.setOnOffAlert = false
            // this.email = ''
            // this.settimealert = ''
            this.$refs.csv.value = null
        },
        async finishStepTour () {
            this.isDialogUploadFileShown = false
            this.isDialogConNoticUploadShown = false
            this.isDialogAddUserShown = false
            this.isDialogEditUserShown = false
            this.isDialogSettingAlertShown = false
            this.isDialogConfirmAddUserShown = false
            this.isDialogConfirmCancleAddUserShown = false
            this.isDialogConfirmEditUserShown = false
            this.isDialogConfirmDeleteUserShown = false
            this.isDialogEditAlertShown = false
            this.isDialogConfirmDeleteActivityShown = false
            setTimeout(() => {
                this.getControl()
                this.getDataTable()
            }, 500)
            await axios.post(apiUrl + '/api/status/recommend', {
                command: 'dissettingpdpa'
            })
        }
    },
    watch: {
      tabIndex: async function () {
        if (this.tabIndex === 0) {
            window.analytics.track(`[Setting][Whitelist]`, {}, {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
            await axios.post(apiUrl + '/api/dashboard/stage', {
                type: 'menu',
                username: this.user,
                menu: 'whitelist',
                submenu: this.tabMenu[this.tabIndex]
            })
          this.getDataTable()
        } else if (this.tabIndex === 1) {
            window.analytics.track(`[Setting][Manage Recipient]`, {}, {
                integrations: {
                    Amplitude: {
                    'session_id': this.ampid
                    }
                }
            })
            await axios.post(apiUrl + '/api/dashboard/stage', {
                type: 'menu',
                username: this.user,
                menu: 'whitelist',
                submenu: this.tabMenu[this.tabIndex]
            })
            this.getControl()
        }
      },
      recommend: function () {
        if (this.recommend && this.$router.history.current.name === 'whiteList') {
          setTimeout(() => {
            this.$tours['recommand-tour-setting-pdpa'].start()
          }, 1500)
        }
      },
      search: function () {
        window.analytics.track(`[Setting][Notification][Search]`, {
            value: {
                keyword: this.search
            }
        }, {
            integrations: {
                Amplitude: {
                'session_id': this.ampid
                }
            }
        })
      }
    }
}

</script>

<style scoped>
.container-whitelist {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    margin-bottom: 60px;
}
#tab-wl {
    text-transform: none !important;
}
#control{
    width: 50%;
}
#icon {
    font-size: 250px;
}
#text-csv {
    display: flex;
    flex-direction: row;
    margin-top: 15px;
    padding: 0;
}
#text-csv > span {
    margin: 3px;
}

#btn-box {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-items: center;
}

#btn-box > span {
    align-items: center;
    padding: 0;
    margin: 12px 5px;
}

#btn-box-inside{
    color: #000;
    text-transform: capitalize;
}

.red--text {
    margin: 0;
}

#box-setting {
    padding: 10px;
}

#btn-switch {
    width: 50%;
    margin: 0;
    padding: 0;
    margin-left: 42%;
}
@media only screen and (max-width: 600px) {
    #icon {
        font-size: 150px;
    }
    #text-csv {
        flex-direction: row;
    }
    #text-csv > span {
        font-size: 14px;
    }
    #btn-box {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-items: center;
    }
    #btn-box > span {
        align-items: center;
        padding: 0;
        margin: 0 auto;
    }
}

@media only screen and (max-width: 375px) {
     #icon {
        font-size: 50px;
    }
    #text-csv > span {
        font-size: 12px;
    }
    .text-light{
        font-size: 12px;
    }
}

@media only screen and (max-width: 320px) {
    #text-csv > span {
        font-size: 10px;
    }
    .text-light{
        font-size: 10px;
    }
}

.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0,0,0,.8);
}

.tour-body {
  max-width: 900px !important;
  min-width: 450px !important;
  max-height: 300px !important;
  padding: 0 !important;
  margin: auto !important;
  background-color: #212121 !important;
}
.tour-btn-start {
  color: #fff !important;
  background-color: #009688 !important;
  box-shadow: none !important;
  border-radius: 13px !important;
  width: 260px !important;
  outline: none !important;
  margin: 0 auto !important;
  margin-top: 10px !important;
  text-transform: none !important;
  font-size: 16px !important;
}
.tour-btn-skip {
  position: relative !important;
  left: 190px !important;
  text-transform: none !important;
  outline: none !important;
  font-size: 13px !important;
  margin: 10px 0 !important;
  color: #616161 !important;
  text-decoration-line: underline !important;
  font-style: normal !important;
  font-weight: normal !important;
}
.tour-btn-back {
  margin:0 10px !important;
  color: #212121 !important;
  outline: none !important;
  background-color: #fff !important;
  text-transform: none !important;
  box-shadow: none !important;
  border-radius: 13px !important;
}
.tour-btn-next {
  margin:0 10px;
  color: #fff !important;
  outline: none !important;
  background-color: #009688  !important;
  text-transform: none !important;
  box-shadow: none !important;
  border-radius: 13px !important;
}
.tour-btn-finish {
  color: #fff !important;
  outline: none !important;
  background-color: #009688  !important;
  text-transform: none !important;
  box-shadow: none !important;
  border-radius: 13px !important;
  width: 25px !important;
  margin: 20px auto;
}
.tour-header {
  border-bottom: 1px solid #BDBDBD !important;
  margin: 12px 30px !important;
  padding: 0 !important;
}
.tour-content {
  font-size: 14px !important;
}

</style>



// WEBPACK FOOTER //
// src/views/whiteListPage.vue